<template>
  <article v-bind:class="{
    'news-thumbnail': true,
    'grey-background': theme === 'grey-background',
  }">
    <router-link :to="{name: 'OneNewsView', params: {id: id}}">
      <div class="thumbnail-container">
        <!--      <img
                  :src="imgSrc"
                  alt="Medical service illustration"
                  class="thumbnail-image"
              />-->
        <div :style="`background-image: url(/storage/${imgSrc})`" class="thumbnail-image"></div>
      </div>
      <div class="news-thumbnail-info">
        <div class="news-thumbnail-date">{{ subtitle }}</div>
        <h2 class="news-thumbnail-title">{{ title }}</h2>
      </div>
    </router-link>
  </article>
</template>

<script>


export default {
  name: 'ServiceThumbnail',
  components: {},
  props: {
    id: {
      type: String,
      required: true
    },
    imgSrc: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    theme: {
      type: String
    }
  }
}
</script>

<style lang="scss" scoped>
.news-thumbnail {
  border-radius: 20px;
  padding: $spacing-2;
  overflow: hidden;
  cursor: pointer;
  font-family: $font-regular;
  height: 420px;

  .thumbnail-container {
    overflow: hidden;
    border-radius: 20px;
    display: flex;
    justify-content: center;
    align-items: center;

    .thumbnail-image {
      width: 100%;
      transition: 0.3s ease-in-out;
      height: 200px;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;

    }
  }

  .news-thumbnail-info {
    color: $color-brown;
    text-align: left;

    .news-thumbnail-date {
      font-size: 12px;
      margin: $spacing-1 0;
    }

    .news-thumbnail-title {
      font-size: 16px;
    }
  }

}

.grey-background {
  background: $color-grey;
}

@media screen and (min-width: 768px) {
  .news-thumbnail {
    padding: $spacing-4;

    .service-thumbnail-info {
      .news-thumbnail-title {
        font-size: $paragraph-1;
      }
    }


    &:hover {
      transition: 0.3s ease-in-out;
      background-color: #ddd1cb;

      .thumbnail-image {
        transform: scale(1.1);
      }
    }
  }
}

@media screen and (min-width: 1500px) {
  .news-thumbnail {
    .thumbnail-container {
      .thumbnail-image {
        height: 250px;
      }
    }

  }
}
</style>